import { ValueBadge } from '../../../design-system';
import type { ReferenceJobProfile } from '../model/types';
import { CatalogDetailDialog } from './ReferenceLifecycle';

type JobProfileDetailDialogProps = {
  profile?: ReferenceJobProfile;
  canWrite: boolean;
  onClose: () => void;
  onEdit: () => void;
  onLifecycle: (action: 'end' | 'reactivate') => void;
};

export function JobProfileDetailDialog({
  profile,
  canWrite,
  onClose,
  onEdit,
  onLifecycle,
}: JobProfileDetailDialogProps) {
  return (
    <CatalogDetailDialog
      item={profile}
      kindLabel="직무"
      canWrite={canWrite}
      canEdit={profile?.status !== 'SCHEDULED'}
      editDisabledReason={
        profile?.status === 'SCHEDULED' ? '사용 예정인 직무 속성은 적용일 이후 수정할 수 있습니다.' : undefined
      }
      extraItems={profile ? [['직군', profile.jobFamily ? <ValueBadge label={profile.jobFamily.descriptor} /> : '직군 미지정']] : []}
      onClose={onClose}
      onEdit={onEdit}
      onLifecycle={onLifecycle}
    />
  );
}
